var indentStyle = {"indentZero":"uSmJR","indentOne":"VcD2f","indentTwo":"Irntm","indentThree":"FLmkY","indentFour":"dWf96","indentFive":"KrEFF","indentSix":"rm13X"};

export { indentStyle as i };
//# sourceMappingURL=indentation-9a66a829.js.map
